import { postDataAccessComparisonExportStart } from '@api';

import { createPostAsyncSlice, SagaYieldType } from '@sonar-software/xuder';

export const postCoreDataSecurityAccessComparisonExportSlice = createPostAsyncSlice({
	name: 'CoreDataSecurityAccessComparisonExport',
	receive: true,
	request: true,
	requestHandler: postDataAccessComparisonExportStart,
	retainDataOnRequest: false,
	yieldType: SagaYieldType.Every
});
